import {
  DiagramArtifactPromptDiagramArtifactPromptType,
  HouseholdChatPromptTemplate,
} from '@/types/schema';

import DetailedDiagramIllustration from './illustrations/estateDistribution.svg?react';
import SimpleDiagramIllustration from './illustrations/singleEntityDistribution.svg?react';

export const TEMPLATE_DETAILS = {
  [DiagramArtifactPromptDiagramArtifactPromptType.EstateDistributionDetailed]: {
    promptTemplate: HouseholdChatPromptTemplate.EstateDistributionDetailed,
    title: 'Detailed estate distribution',
    description:
      'Explore estate distributions with trust and beneficiary details',
    Illustration: DetailedDiagramIllustration,
  },
  [DiagramArtifactPromptDiagramArtifactPromptType.EstateDistributionSimple]: {
    promptTemplate: HouseholdChatPromptTemplate.EstateDistributionSimple,
    title: 'Simple estate distribution',
    description: 'See a high-level overview of estate distributions',
    Illustration: SimpleDiagramIllustration,
  },
};
